<template>
  <transition name="dialog" appear>
    <div class="dialog-mask" @click="close">
      <div class="dialog-wrapper">
        <div class="dialog-container" @click.stop="">
          <div class="status">
            <icon icon-class="cricle-success" class="success" v-if="statusType == 'success'"></icon>
            <icon icon-class="fail" class="fail" v-else></icon>
          </div>
          <h4>{{title}}</h4>
          <p v-if="subTitle">{{subTitle}}</p>
          <div class="cancel"><button class="cancel-button" @click="close">返回</button></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
  .dialog-mask{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    .dialog-wrapper{
      display: table-cell;
      vertical-align: middle;
      .dialog-container{
        width: 90%;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 14px 0 rgba(75,119,174,0.25);
        overflow: hidden;
        transition: all .3s ease;
        padding: 39px 0 32px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .status{
          display: flex;
          justify-content: center;
          align-items: center;
          svg{
            font-size: 55px;
            &.success{
              color: @xile;
            }
            &.fail{
              color: #999;
            }
          }
        }
        h4{
          margin-top: 20px;
          font-size: 16px;
          line-height: 16px;
          color: @black;
          font-weight: bold;
        }
        p{
          margin-top: 12px;
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
        .cancel{
          width: 240px;
          margin: 40px auto 0;
          .cancel-button{
            @button-base();
            width: 100%;
            height: 36px;
            font-weight: normal;
          }
        }
      }
    }
  }
  // 动画
  .dialog-enter {
    opacity: 0;
  }

  .dialog-leave-active {
    opacity: 0;
  }

  .dialog-enter .dialog-container,
  .dialog-leave-active .dialog-container {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      statusType: {
        type: String,
        default: 'error'
      },
      title: {
        type: String,
        default: '默认标题'
      },
      subTitle: String,
    },
    data() {
      return {}
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Common/statusDialog.vue